'use client';
import clsx from 'clsx';
import { useRef } from 'react';
import { mergeProps, useButton, useDisclosure, useFocusRing } from 'react-aria';
import { useDisclosureState } from 'react-stately';
import { OpenAPISelect, OpenAPISelectItem, useSelectState } from './OpenAPISelect';
import { Section, SectionBody, SectionHeader, SectionHeaderContent } from './StaticSection';
/**
 * To optimize rendering, most of the components are server-components,
 * and the interactiveness is mainly handled by a few key components like this one.
 */
export function InteractiveSection(props) {
    var _a, _b;
    var id = props.id, className = props.className, _c = props.toggeable, toggeable = _c === void 0 ? false : _c, _d = props.defaultOpened, defaultOpened = _d === void 0 ? true : _d, _e = props.tabs, tabs = _e === void 0 ? [] : _e, _f = props.defaultTab, defaultTab = _f === void 0 ? (_a = tabs[0]) === null || _a === void 0 ? void 0 : _a.key : _f, header = props.header, overlay = props.overlay, _g = props.toggleIcon, toggleIcon = _g === void 0 ? '▶' : _g, selectIcon = props.selectIcon, _h = props.stateKey, stateKey = _h === void 0 ? 'interactive-section' : _h;
    var state = useDisclosureState({
        defaultExpanded: defaultOpened,
    });
    var panelRef = useRef(null);
    var triggerRef = useRef(null);
    var _j = useDisclosure({}, state, panelRef), triggerProps = _j.buttonProps, panelProps = _j.panelProps;
    var buttonProps = useButton(triggerProps, triggerRef).buttonProps;
    var _k = useFocusRing(), isFocusVisible = _k.isFocusVisible, focusProps = _k.focusProps;
    var store = useSelectState(stateKey, defaultTab);
    var selectedTab = (_b = tabs.find(function (tab) { return tab.key === store.key; })) !== null && _b !== void 0 ? _b : tabs[0];
    return (<Section id={id} className={clsx('openapi-section', toggeable ? 'openapi-section-toggeable' : null, className, toggeable ? "".concat(className, "-").concat(state.isExpanded ? 'opened' : 'closed') : null)}>
            {header ? (<SectionHeader onClick={function () {
                if (toggeable) {
                    state.toggle();
                }
            }} className={className}>
                    <SectionHeaderContent className={className}>
                        {(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.body) && toggeable ? (<button {...mergeProps(buttonProps, focusProps)} ref={triggerRef} className={clsx('openapi-section-toggle', "".concat(className, "-toggle"))} style={{
                    outline: isFocusVisible
                        ? '2px solid rgb(var(--primary-color-500) / 0.4)'
                        : 'none',
                }}>
                                {toggleIcon}
                            </button>) : null}
                        {header}
                    </SectionHeaderContent>
                    {/* biome-ignore lint/a11y/useKeyWithClickEvents: we prevent default here */}
                    <div className={clsx('openapi-section-header-controls', "".concat(className, "-header-controls"))} onClick={function (event) {
                event.stopPropagation();
            }}>
                        {tabs.length > 1 ? (<OpenAPISelect stateKey={stateKey} items={tabs} onSelectionChange={function () {
                    state.expand();
                }} icon={selectIcon} placement="bottom end">
                                {tabs.map(function (tab) { return (<OpenAPISelectItem key={tab.key} id={tab.key} value={tab}>
                                        {tab.label}
                                    </OpenAPISelectItem>); })}
                            </OpenAPISelect>) : null}
                    </div>
                </SectionHeader>) : null}
            {(!toggeable || state.isExpanded) && (selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.body) ? (<SectionBody ref={panelRef} {...panelProps} className={className}>
                    {selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.body}
                </SectionBody>) : null}
            {overlay ? (<div className={clsx('openapi-section-overlay', "".concat(className, "-overlay"))}>
                    {overlay}
                </div>) : null}
        </Section>);
}
